import React from 'react';

export const Action = ({ hasButtonConfiguration, actionData, isArray = true }) => {
    if (!hasButtonConfiguration) return null;

    const renderButton = (item, index) => (
        <a
            key={index}
            href={item.buttonLink}
            className="flex justify-center align-center decoration-none"
            rel={item.isNoFollow ? 'nofollow noopener noreferrer' : ''}
            style={{
                height: '54px',
                borderRadius: '10px',
            }}
        >
            {item.buttonName}
        </a>
    );

    return (
        <div className='hero-action'>
            <div className={`grid col-${actionData?.length} gap-5`}>
                {isArray ? actionData?.map((item, index) => renderButton(item, index)) : renderButton(actionData, 0)}
            </div>
        </div>
    );
};
